import enGB from './en-GB.json';
import deCH from './de-CH.json';

export default {
  'en-GB': enGB,
  'de-CH': deCH,
};
